import {loadRoleAccount} from 'common/js/cache.js'

const state = {
  account: loadRoleAccount()//账号
}


export default state



// WEBPACK FOOTER //
// ./src/store/user/state.js